import React from 'react'
import Column from './column'
import HeaderColumn from './headerColumn'
import ReportsRepo from '../../../../../../utils/repository/repoertsRepo'
import { NEW_REPORT_ID, ReportFillingType } from '../../../../../../constnats/reportConstants';
import CopyDataModal from './copyReportDataModal'
import ReportUtils from '../../../../../../utils/reportUtils';
import DescriptorPropsColumns from './descriptorPropsColumns';
import { ConfigProps } from '../../../../../../components/financialTables/configuration/constants';
import { DescriptorProps } from '../../../../../../constnats/descriptor';
import SimpleBar from 'simplebar-react';
import { ProvenanceSplitLayout, SourceViewProvider } from '../../../../../../components/sourceView';

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: this.props.reports.slice(),
      modal: <></>,
      highlightedRows: [],
      selectedProvenance: null,
    }

    this.columnWidth = "auto"
    this.dirtyReports = new Set()
    this.simplebarRef = React.createRef();
    // this.refs = []

    this.addReport = this.addReport.bind(this)
    this.hasNewNotSavedReport = false
  }

  componentWillReceiveProps(nextProps) {
    const newReports = nextProps.reports.slice()
    const theNewReport = this.getTheNewReport()
    if (theNewReport !== null && this.hasNewNotSavedReport) {
      newReports.unshift(theNewReport)
    }

    this.setState({ reports: newReports })
    const repIds = nextProps.reports.map(r => r.id)
    for (const id of this.dirtyReports) {
      if (!repIds.includes(id)) {
        this.dirtyReports.delete(id)
      }
    }
    this.updateParentDirtyState()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sourceViewEnabled && !this.props.sourceViewEnabled) {
      this.setState({ selectedProvenance: null })
    }
    if(this.props.showFieldsSettings !== prevProps.showFieldsSettings) {
      this.simplebarRef.current.recalculate()
    }
  }

  isNew(report) {
    return report.id === NEW_REPORT_ID
  }

  getTheNewReport() {
    const firstReport = this.state.reports[0]
    return firstReport && this.isNew(firstReport) ? firstReport : null
  }

  addReport() {
    if (this.getTheNewReport() !== null) {
      return
    }

    const report = Object.assign(
      ReportUtils.createEmptyReport(NEW_REPORT_ID), {
      [DescriptorProps.TYPE]: ReportFillingType.ORIGINAL_FILLING
    })

    const copy = this.state.reports.slice()
    copy.unshift(report)
    this.hasNewNotSavedReport = true
    this.setState({ reports: copy })
  }

  onReportDirtyChange(dirty, id) {
    if (dirty) {
      this.dirtyReports.add(id)
    } else {
      this.dirtyReports.delete(id)
    }

    this.updateParentDirtyState()
  }

  updateParentDirtyState() {
    if (this.dirtyReports.size > 0) {
      this.props.setDirty(true)
    } else {
      this.props.setDirty(false)
    }
  }

  save(report, onSuccess) {

    const finalize = () => {
      onSuccess()
      this.props.onChange()
    }

    if (this.isNew(report)) {
      delete report.id
      report.schemaId = this.props.schemaId
      ReportsRepo.save(report, res => {
        this.hasNewNotSavedReport = false;
        finalize()
      })
    } else {
      ReportsRepo.update(report, res => finalize())
    }
  }

  delete(id, onSuccess) {
    if (id === NEW_REPORT_ID) {
      this.hasNewNotSavedReport = false
      this.props.onChange()
    } else {
      ReportsRepo.delete(id, res => {
        this.props.onChange()
        onSuccess()
      })
    }
  }


  openCopyDataModal(report) {
    this.setState({
      modal: <CopyDataModal
        descriptors={this.props.descriptors}
        schemaId={this.props.schemaId}
        srcReport={report}
        copyTargets={this.props.getCopyTargets(report)}
        closeModal={hasChanges => {
          this.setState({ modal: null })
          if (hasChanges) {
            this.props.onChange()
          }
        }}
      />
    })
  }

  columns() {
    const state = this.state
    return state.reports.map((r, i) =>
      <div key={r.id + "_column"} className='inline-block'>
        <Column
          highlightedRows={state.highlightedRows}
          isNew={this.isNew(r)}
          save={(report, onSuccess) => this.save(report, onSuccess)}
          delete={(reportId, onSuccess) => this.delete(reportId, onSuccess)}
          descriptors={this.props.descriptors}
          schemaId={this.props.schemaId}
          schemaName={this.props.schemaName}
          report={r}
          openCopyDataModal={report => this.openCopyDataModal(report)}
          setDirty={dirty => this.onReportDirtyChange(dirty, r.id)}
          readOnly={this.props.readOnly}
          companyId={this.props.companyId}
          advancedTableCfg={this.props.advancedTableCfg}
          filterCfg={this.props.filterCfg}
        />
      </div>
    )
  }

  render() {
    console.log("RENDER TABLE")
    const columns = this.columns()
    const { sourceViewEnabled } = this.props
    const { selectedProvenance } = this.state
    return <SourceViewProvider sourceViewEnabled={sourceViewEnabled}
      onValueClick={provenance => this.setState({ selectedProvenance: provenance })}
      reports={this.state.reports}>
      {this.state.modal}
      <ProvenanceSplitLayout enabled={sourceViewEnabled} provenance={selectedProvenance}
        loading={this.props.provenanceLoading} topOffset={60} leftPaneOverflowVisible>
      <div className="reportTable" textalign='center'>

        <HeaderColumn position={columns.length ? 'abosulte' : 'relative'}
          standardizedLabels={this.props.standardizedLabels}
          readOnlyMode={this.props.readOnly}
          addReport={this.addReport}
          descriptors={this.props.descriptors}
          highlightedRows={this.state.highlightedRows}
          setHighlightedRows={highlightedRows => this.setState({ highlightedRows })}
          advancedTableCfg={this.props.advancedTableCfg}
          flipSign={this.props.flipSign}
        />
        {
          this.props.showFieldsSettings && (
              <div className={`inline-block dataColumns fieldSettingsColumn headerWidth_${columns.length ? this.props.advancedTableCfg[ConfigProps.HEADER_COLUMN_WIDTH] : ""} ${columns.length ? 'abosulte' : 'relative'}`}>
                  <DescriptorPropsColumns
                      readOnlyMode={this.props.readOnly}
                      addReport={this.addReport}
                      highlightedRows={this.state.highlightedRows}
                      setHighlightedRows={(highlightedRows) => this.setState({ highlightedRows })}
                      flatDescriptors={this.props.flatDescriptors}
                  />
              </div>
          )
        }
          <SimpleBar ref={this.simplebarRef} autoHide={false}>
          <div className={`dataColumns headerWidth_${this.props.advancedTableCfg[ConfigProps.HEADER_COLUMN_WIDTH]}${this.props.showFieldsSettings ? "_SFS": ""}`}>
            {columns}
          </div>
          </SimpleBar>
      </div>
      </ProvenanceSplitLayout>
    </SourceViewProvider>
  }
}

export default Table
